import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const then: SugarElementInfo = { name: "then", availableChildren: { type: AvailableChildrenType.Any } };
